import type { AppSettings } from '../run/types';

type Props = {
  settings: AppSettings;
  onChange: (settings: AppSettings) => void;
  onBack: () => void;
  onClearData: () => Promise<void>;
};

export function SettingsScreen({ settings, onChange, onBack, onClearData }: Props) {
  return (
    <main className="center-screen">
      <section className="panel settings-panel">
        <button className="back-button" onClick={onBack}>
          ← Home
        </button>
        <p className="eyebrow">Local preferences</p>
        <h1>Settings</h1>

        <fieldset className="setting-group">
          <legend>Default run mode</legend>
          <label className="radio-card">
            <input
              type="radio"
              name="mode"
              checked={settings.mode === 'practice'}
              onChange={() => onChange({ ...settings, mode: 'practice' })}
            />
            <span>
              <strong>Practice</strong>
              <small>Skip is available immediately.</small>
            </span>
          </label>
          <label className="radio-card">
            <input
              type="radio"
              name="mode"
              checked={settings.mode === 'competitive'}
              onChange={() => onChange({ ...settings, mode: 'competitive' })}
            />
            <span>
              <strong>Competitive</strong>
              <small>Skip follows each game’s cooldown policy.</small>
            </span>
          </label>
        </fieldset>

        <label className="toggle-row">
          <span>
            <strong>Sound</strong>
            <small>Foundation setting; game audio arrives during polish.</small>
          </span>
          <input
            type="checkbox"
            checked={settings.sound}
            onChange={(event) => onChange({ ...settings, sound: event.target.checked })}
          />
        </label>
        <label className="toggle-row">
          <span>
            <strong>Reduce motion</strong>
            <small>Shorten countdowns and transitions.</small>
          </span>
          <input
            type="checkbox"
            checked={settings.reducedMotion}
            onChange={(event) => onChange({ ...settings, reducedMotion: event.target.checked })}
          />
        </label>

        <div className="danger-zone">
          <h2>Local data</h2>
          <p>Delete saved runs and history from this browser.</p>
          <button
            className="button button--danger"
            onClick={() => {
              if (window.confirm('Delete all locally saved runs and history?')) void onClearData();
            }}
          >
            Clear local data
          </button>
        </div>
      </section>
    </main>
  );
}
